import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

/** @augments {PureComponent<any, any>} */
class Trash extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path d="M14,2.5 L14,0.5 C14,0.2 13.8,0 13.5,0 L4.5,0 C4.2,0 4,0.2 4,0.5 L4,2.5 C4,2.8 3.8,3 3.5,3 L0.5,3 C0.2,3 0,3.2 0,3.5 L0,4.5 C0,4.8 0.2,5 0.5,5 L17.5,5 C17.8,5 18,4.8 18,4.5 L18,3.5 C18,3.2 17.8,3 17.5,3 L14.5,3 C14.2,3 14,2.8 14,2.5 L14,2.5 Z" />
                <path d="M0.5,22 L17.5,22 C17.8,22 18,21.8 18,21.5 L18,7.5 C18,7.2 17.8,7 17.5,7 L0.5,7 C0.2,7 0,7.2 0,7.5 L0,21.5 C0,21.8 0.2,22 0.5,22 L0.5,22 Z M14.5,9 L15.5,9 C15.8,9 16,9.2 16,9.5 L16,19.5 C16,19.8 15.8,20 15.5,20 L14.5,20 C14.2,20 14,19.8 14,19.5 L14,9.5 C14,9.2 14.2,9 14.5,9 L14.5,9 Z M10.5,9 L11.5,9 C11.8,9 12,9.2 12,9.5 L12,19.5 C12,19.8 11.8,20 11.5,20 L10.5,20 C10.2,20 10,19.8 10,19.5 L10,9.5 C10,9.2 10.2,9 10.5,9 L10.5,9 Z M6.5,9 L7.5,9 C7.8,9 8,9.2 8,9.5 L8,19.5 C8,19.8 7.8,20 7.5,20 L6.5,20 C6.2,20 6,19.8 6,19.5 L6,9.5 C6,9.2 6.2,9 6.5,9 L6.5,9 Z M2.5,9 L3.5,9 C3.8,9 4,9.2 4,9.5 L4,19.5 C4,19.8 3.8,20 3.5,20 L2.5,20 C2.2,20 2,19.8 2,19.5 L2,9.5 C2,9.2 2.2,9 2.5,9 L2.5,9 Z" />
            </SvgIcon>
        );
    }
}

export default Trash;
